import { render, staticRenderFns } from "./IndexJiazhang.vue?vue&type=template&id=5ed8cd5c&scoped=true&"
import script from "./IndexJiazhang.vue?vue&type=script&lang=js&"
export * from "./IndexJiazhang.vue?vue&type=script&lang=js&"
import style0 from "./IndexJiazhang.vue?vue&type=style&index=0&id=5ed8cd5c&prod&lang=scss&"
import style1 from "./IndexJiazhang.vue?vue&type=style&index=1&id=5ed8cd5c&prod&lang=scss&scoped=true&"
import style2 from "./IndexJiazhang.vue?vue&type=style&index=2&id=5ed8cd5c&prod&lang=scss&"
import style3 from "./IndexJiazhang.vue?vue&type=style&index=3&id=5ed8cd5c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed8cd5c",
  null
  
)

export default component.exports